import { httpClient } from "..";
import { StatisticsForGoogleAnalytics } from "../types";

export const getStatisticsSummary = async (): Promise<StatisticsForGoogleAnalytics | null> => {
  const { 
    data: { 
      returned, 
      success 
    } 
  } = await httpClient.get(`/statistics/summary`);

  if (!success) {
    return null;
  }

  return returned as StatisticsForGoogleAnalytics;
};
